import { render, staticRenderFns } from "./OfferBulkCheckboxesItem.vue?vue&type=template&id=a2e8daac&scoped=true&"
import script from "./OfferBulkCheckboxesItem.vue?vue&type=script&lang=ts&"
export * from "./OfferBulkCheckboxesItem.vue?vue&type=script&lang=ts&"
import style0 from "./OfferBulkCheckboxesItem.vue?vue&type=style&index=0&id=a2e8daac&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e8daac",
  null
  
)

export default component.exports